import { systemConstants } from '_constants';

const initialState = { streamlineMode: true };

export function systemData(state = initialState, action) {
    switch (action.type) {
        // Get Reviews
        case systemConstants.RENEW_NOTIFICATION_REQUEST:
            return {
                ...state,
                renewNotificationRequest: true,
            };
        case systemConstants.RENEW_NOTIFICATION_SUCCESS:
            return {
                ...state,
                renewNotificationRequest: false,
                renewNotifications: action.data.renew
            };
        case systemConstants.RENEW_NOTIFICATION_FAILURE:
            return {
                ...state,
                renewNotificationRequest: false,
            };
        case systemConstants.TERMS_RENEWED_REQUEST:
            return {
                ...state,
                termsRenewedRequest: true,
            };
        case systemConstants.TERMS_RENEWED_SUCCESS:
            return {
                ...state,
                termsRenewedRequest: false,
            };
        case systemConstants.TERMS_RENEWED_FAILURE:
            return {
                ...state,
                termsRenewedRequest: false,
            };
        default:
            return state;
    }
};

